import _ from "lodash";
import { ReactNode } from "react";

import { FlexBox } from "~frontend/components/FlexBox";
import PageContainer from "~frontend/components/PageContainer";
import { useBreadcrumbs } from "~frontend/providers/BreadcrumbsProvider";

import { ComplianceInvites } from "./invites";
import { TenDlcRegistrationTable } from "./ten-dlc/TenDlcRegistrationTable";
import { TollFreeRegistrationTable } from "./toll-free/TollFreeRegistrationTable";

export const ComplianceRegistrations = (): ReactNode => {
  useBreadcrumbs([
    {
      label: "10DLC and Toll-Free Registrations",
      path: "/staff/compliance-registrations",
    },
  ]);

  return (
    <PageContainer maxWidth="xl">
      <FlexBox direction="column" gap={2}>
        <TenDlcRegistrationTable />
        <TollFreeRegistrationTable />
        <ComplianceInvites />
      </FlexBox>
    </PageContainer>
  );
};
